import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=5016a2dd&scoped=true"
import script from "./MainView.vue?vue&type=script&setup=true&lang=js"
export * from "./MainView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MainView.vue?vue&type=style&index=0&id=5016a2dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5016a2dd",
  null
  
)

export default component.exports